let language = {
    STORE_PRODUCT_INACTIVE_PARTNER_DES1:"Your E-Shop is still not ready yet, please activate your E-Shop first,and try again later.",
    STORE_PRODUCT_INACTIVE_PARTNER_DES2:"If you miss the activating mail, please go to",
    STORE_PRODUCT_INACTIVE_PARTNER_SETTING:"Partner Setting",
    STORE_PRODUCT_INACTIVE_PARTNER_DES3:",click",
    STORE_PRODUCT_INACTIVE_PARTNER_DES4:"[Activate Your e-shop].",
    STORE_PRODUCT_INACTIVE_PARTNER_DES5:" login to your e-mail, and open the link on the e-mail send by",

};

export { language }